import { useState } from 'react';

export function useQuickTradeState() {
  const [quantityBasis, setQuantityBasis] =
    useState<'DOLLARS' | 'QUANTITY'>('DOLLARS');
  const [quantityBasisValue, setQuantityBasisValue] = useState(124.56);
  const [limitPrice, setLimitPrice] = useState(13.4);
  const [orderType, setOrderType] = useState<'MARKET' | 'LIMIT'>('MARKET');
  const [selectedTemplate, setSelectedTemplate] = useState('none');


  return {
    quantityBasis,
    setQuantityBasis,
    quantityBasisValue,
    setQuantityBasisValue,
    limitPrice,
    setLimitPrice,
    orderType,
    setOrderType,
    selectedTemplate,
    setSelectedTemplate
  }
}
